import { faTag } from "@jewlr/pro-regular-svg-icons/faTag"
import { useMemo } from "react"
import { useSelector } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { cn } from "styles/utils"

const PriceBadge = () => {
  const { pricing, priorityBadge, wizardLoading } = useSelector((state) => ({
    // holidayDelivery: state.wizard.shipping?.main?.available_holiday_delivery,
    pricing: state.wizard.price_and_promo,
    priorityBadge: state.wizard.priorityBadge,
    wizardLoading: state.wizard.loading,
  }))

  const { className: secondMicroBannerClassName, ...secondMicroBannerProps } =
    useSelector((state) => state.sale.second_microbanner?.style || {})

  const badgeContent = useMemo(() => {
    if (priorityBadge) {
      return (
        <>
          <FontAwesomeIcon
            className="text-8 tablet:text-16 mr-6 text-white"
            icon={faTag}
          />
          {priorityBadge.label}
        </>
      )
    }

    // if (holidayDelivery) {
    //   return `${sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday} Delivery`
    // }

    if (pricing.on_sale) {
      const percentageSavings = (
        ((pricing.regular_pricing - pricing.price_to_display) * 100) /
        pricing.regular_pricing
      ).toFixed(0)

      return `${percentageSavings}% Off`
    }

    return null
  }, [priorityBadge, pricing])
  // }, [priorityBadge, pricing, holidayDelivery])

  if (wizardLoading || !Object.keys(pricing).length || !badgeContent) {
    return null
  }

  return (
    <div
      className={cn(
        "text-14 tablet:text-12 bg-ruby tablet:px-8 h-22 tablet:h-20 flex items-center justify-center rounded-full px-12 font-semibold uppercase -tracking-tight text-white",
        secondMicroBannerClassName
      )}
      {...secondMicroBannerProps}
    >
      {badgeContent}
    </div>
  )
}

export default PriceBadge
